import { useDroppable } from '@dnd-kit/core'
import type React from 'react'

import { StyledList } from './styles'

interface DndDroppableProps {
  children: React.ReactNode
}

export function SortableList({ children }: DndDroppableProps) {
  const { isOver, setNodeRef } = useDroppable({
    id: 'droppable',
  })
  const style = {
    backgroundColor: isOver ? 'green' : undefined,
  }

  return (
    <StyledList ref={setNodeRef} style={style} data-testid="draggable-col">
      {children}
    </StyledList>
  )
}
